import { LIB_VERSION } from '../../version';
import { SENTRY_VIEWER_SCRIPT_DSN } from '../../common/constants/sentry-dsn';
export const normalizeError = (error) => {
    if (typeof Response !== 'undefined' &&
        error instanceof Response &&
        error.constructor.name !== 'Error') {
        return Error(`Failed to fetch ${error.url} with status ${error.status} - ${error.statusText}`);
    }
    return error;
};
export const decorateActionsWithLogger = (actions, sentry, logToConsole) => {
    const decoratedActions = {};
    const decorate = (action, key) => (...args) => {
        const captureToSentry = (e) => sentry.captureException(normalizeError(e), {
            extra: { action: key },
            tags: { capturedBy: 'action monitor' },
        });
        try {
            const response = action(...args);
            if (response instanceof Promise) {
                response.catch((error) => {
                    if (error && error.status !== 200 && error.status !== 500) {
                        return;
                    }
                    logToConsole && console.error(error);
                    captureToSentry(error);
                });
            }
            return response;
        }
        catch (error) {
            logToConsole && console.error(error);
            captureToSentry(error);
        }
    };
    Object.keys(actions).forEach((key) => {
        const action = actions[key];
        decoratedActions[key] = decorate(action, key);
    });
    return decoratedActions;
};
export const createSentryMonitor = ({ platformAPIs, isSSR, }) => {
    const raven = platformAPIs.monitoring.createMonitor(SENTRY_VIEWER_SCRIPT_DSN, (data) => {
        data.environment = isSSR ? `Worker-SSR` : `Worker-CSR`;
        return data;
    });
    if (raven && raven.setRelease) {
        raven.setRelease(LIB_VERSION);
    }
    return {
        raven,
        captureException: (...args) => {
            raven.captureException(...args);
            return raven.lastEventId();
        },
    };
};
//# sourceMappingURL=monitoring.js.map